import React, { useState ,useCallback} from "react";
import { uploadBot ,uploadSampleBot} from "../../Redux/actions/processes";
import "./index.css";
import {useDropzone} from 'react-dropzone';
function UploadFlow(props) {
  const [file, setFile] = useState("");
  let [bot, setBot] = useState('0');
  const [fileName, setFileName] = useState(""); 
  const [loading, setLoading] = useState(false);
  const [enableSubmit, setEnableSubmit] = useState(true);

  const handleSubmit = async e => {
    e.preventDefault();
    if(bot !== '0'){
      let obj = props.sampleBots.find((obj) => obj.id == bot);      
      let payload = {
        id:obj.id.toString(),
        name:obj.name,
      }
      setLoading(true)
      await uploadSampleBot(payload);
      setLoading(false)
      props.uploadSuccess();
    }else {
      setLoading(true);
      await uploadBot(file);
      setLoading(false);
      props.uploadSuccess();
    }
  };
  
  const onDrop = useCallback(acceptedFiles => {
     setFile(acceptedFiles[0]);
     setFileName(acceptedFiles[0].name);
     setEnableSubmit(false);
  }, [])

  const handleChange = async (e) => {
    if(e.target.name === "bot"){
      setBot(e.target.value)
      setEnableSubmit(false);
      }
  }

  const {getRootProps, getInputProps} = useDropzone({onDrop})
  
  return (
    <div className="invite-users-container">
    <div className="upload text-center">
        <form className="my-form">
           <div className="upload-icon">
           <div className="upload1" {...getRootProps()}>
              <input {...getInputProps()} style={{ width:"100% !important" }}
              type="file"
              id="fileElem"
              accept="zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed" />
                <label htmlFor="fileElem">
                <i className="fas fa-file-upload "></i>
                </label>  
            </div>
            </div>
           <div>
            {
              fileName ?
              fileName : 
              "Browse or drag and drop the Action Flow zip file created using publish option in the studio"
            }</div>
          </form>
      </div>
      <div style={{textAlign:"center",margin:"12px 0px 12px 0px",fontSize:"15px",fontWeight:700}}>OR</div>
      <div className="upload text-center">
            <div className="center-align">Select a sample action flow from the below list to try out a flow</div>
             <div className="form-group mr-3">
              <select className="form-control" style={{width:"50%",marginTop:"30px",display:"inline-block"}}id="bot" type="file" name="bot" onChange = {handleChange}>
                <option value="0">Select Flow </option>
                {props.sampleBots.map((obj, index) => <option key={index} value={obj.id}>{obj.name}</option>)}
              </select>
            </div>
      </div>

      <div className="roles-buttons text-center mt-4 mb-2">
        <button
          style={{
            color: "#02ce9d",
            border: "solid 1px #02ce9d",
            background: "none"
          }}
          onClick={() => props.toggle()}
        >
          Cancel
        </button>
        <button
          style={{
            color: "#ffffff",
            border: "#02ce9d",
            background: "#02ce9d",
            boxShadow: "0 6px 10px 0 rgba(2, 206, 157, 0.33)"
          }}
          onClick={handleSubmit} disabled={enableSubmit}
        >
          {loading ? <i style={{ color: "#ffffff" }} className="fas fa-circle-notch fa-spin"></i> : "Publish"}
        </button>
      </div>
    </div>
  );
}

export default UploadFlow;
